<template>
  <v-container class="client applications-application">
    <v-card-text v-if="!isWithdrawn" class="pt-0">
      <v-layout>
        <v-menu
          :close-on-content-click="false"
          max-width="400"
          max-height="50vh"
          offset-y
          bottom
          right
          attach
        >
          <v-btn
            slot="activator"
            small
            :color="themes.client.light.primaryActionButton"
          >
            <v-icon small left>mdi-folder</v-icon>Documents
          </v-btn>
          <v-card>
            <ApplicationDocuments :application="application" />
          </v-card>
        </v-menu>
        <v-menu
          v-if="application.questionnaires && application.questionnaires[0]"
          :close-on-content-click="false"
          max-width="400"
          max-height="50vh"
          offset-y
          bottom
          attach
        >
          <v-btn
            slot="activator"
            small
            :color="themes.client.light.primaryActionButton"
          >
            <v-icon small left>mdi-forum</v-icon>Prescreening Questions
          </v-btn>
          <v-card>
            <ApplicationQuestionnaire :value="application.questionnaires" />
          </v-card>
        </v-menu>
        <v-menu
          bottom
          offset-y
          v-if="showPsychometrics"
          :close-on-content-click="false"
          max-width="400"
          max-height="50vh"
          attach
        >
          <v-btn
            slot="activator"
            small
            :color="themes.client.light.primaryActionButton"
          >
            <v-icon small left>mdi-account-search</v-icon>Assessments
          </v-btn>
          <ApplicationPsychometrics :application="application" />
        </v-menu>

        <ApplicationsExportSelector
          v-if="application.opportunity && isManager"
          :value="[application.id]"
          :opportunity="application.opportunity"
          :profile="application.profile"
          attach
        >
          <v-btn
            small
            slot="activator"
            :color="themes.client.light.primaryActionButton"
          >
            <v-icon small left>mdi-file-pdf-box</v-icon>Export
          </v-btn>
        </ApplicationsExportSelector>

        <v-tooltip bottom v-if="isManager && application && application.id">
          <v-menu
            slot="activator"
            v-model="sharing"
            :close-on-content-click="false"
            offset-y
            bottom
            attach
          >
            <v-btn
              slot="activator"
              @click.stop="sharing = !sharing"
              :color="themes.client.light.primaryActionButton"
              small
            >
              <v-icon small left>mdi-share-variant-outline</v-icon> Share
            </v-btn>
            <FeedbackRequestsForm
              :applications-ids="[application.id]"
              @close="sharing = false"
            />
          </v-menu>
          <span>Share Candidate</span>
        </v-tooltip>
        <v-spacer />
        <div class="text-xs-right">
          <!-- Eligibility Details -->
          <v-menu
            slot="activator"
            v-if="
              application.eligibility &&
              application.eligibility.eligible === false
            "
            offset-y
            left
            attach
          >
            <v-btn
              slot="activator"
              :color="themes.client.light.errorButton"
              round
              small
            >
              <v-icon small left>mdi-account-alert</v-icon>
              Ineligible
            </v-btn>
            <v-card>
              <v-subheader :value="true">
                Application no longer eligible
              </v-subheader>
            </v-card>
          </v-menu>

          <v-btn
            v-else-if="application.complete"
            :color="themes.client.light.successButton"
            round
            small
            @click="viewPdf(application)"
            :loading="generatingPDF"
          >
            <v-icon small left>mdi-pdf-box</v-icon> View
          </v-btn>

          <!-- Completion Details -->
          <v-menu v-else offset-y left attach>
            <v-btn
              slot="activator"
              v-if="application.actionItems && application.actionItems[0]"
              :color="themes.client.light.warningButton"
              round
              small
            >
              <v-icon small left>mdi-account-question</v-icon>
              Incomplete
            </v-btn>
            <v-card>
              <ApplicationCompletionDetails :application="application" />
            </v-card>
          </v-menu>
        </div>
      </v-layout>
    </v-card-text>

    <v-card-text class="text-xs-center" v-if="application.profile">
      <v-layout row wrap align-center justify-space-between>
        <v-flex
          xs10
          offset-xs1
          d-flex
          :md6="showApplicationNotes"
          :offset-md0="showApplicationNotes"
        >
          <v-layout align-center justify-space-around row wrap fill-height>
            <v-flex xs12>
              <v-progress-circular
                size="150"
                :width="10"
                :rotate="-90"
                :value="parseInt(application.completion)"
                :color="
                  application.complete === false
                    ? themes.client.light.warning
                    : themes.client.light.primary
                "
              >
                <v-avatar size="140">
                  <img
                    v-if="application.profile && application.profile.avatar"
                    :src="application.profile.avatar"
                    v-img-orientation-changer
                  />
                  <img v-else src="/img/missing/avatars/original.png" />
                </v-avatar>
              </v-progress-circular>
              <div
                style="
                  position: relative;
                  margin-top: -2rem;
                  margin-right: -8rem;
                "
              >
                <Flag icon v-if="avatarFlag" :value="avatarFlag" />
                <CreateFlag
                  v-else
                  :target="{ ...application.profile, type: 'Profile' }"
                  :profile="application.profile"
                  :filter="['avatar']"
                  @done="refresh"
                >
                  <v-btn
                    icon
                    flat
                    :color="themes.client.light.cancel"
                    slot="activator"
                  >
                    <v-icon>mdi-flag</v-icon>
                  </v-btn>
                </CreateFlag>
              </div>
            </v-flex>

            <v-flex xs12 class="headline mt-2">
              <span v-if="application.profile.firstName">{{
                application.profile.firstName
              }}</span>
              <span v-if="application.profile.lastName"
                >&nbsp;{{ application.profile.lastName }}</span
              >
            </v-flex>
            <v-flex
              xs12
              class="rating-wrapper my-2"
              v-if="showApplicationRating"
            >
              <ApplicationRating
                :application="application"
                :readonly="isWithdrawn"
              />
            </v-flex>
            <v-flex xs12>
              <v-tooltip bottom>
                <v-btn
                  icon
                  small
                  :color="themes.client.light.primaryActionButton"
                  slot="activator"
                  @click="copiedToast('email')"
                  v-clipboard:copy="application.profile.email"
                >
                  <v-icon small>mdi-email</v-icon>
                </v-btn>
                <span> Click to copy {{ application.profile.email }} </span>
              </v-tooltip>
              <MobileNumberValidator
                v-if="application.profile.mobileNumber"
                :value="application.profile.mobileNumber"
              >
                <v-tooltip bottom slot-scope="{ validator }">
                  <v-btn
                    icon
                    small
                    :color="themes.client.light.primaryActionButton"
                    slot="activator"
                    @click="copiedToast('mobile')"
                    v-clipboard:copy="validator.mobileNumber"
                  >
                    <v-icon small>mdi-phone</v-icon>
                  </v-btn>
                  <div>
                    Click to copy
                    <div>
                      {{ validator.mobileNumber }}
                    </div>
                  </div>
                </v-tooltip>
              </MobileNumberValidator>
              <v-tooltip bottom attach>
                <v-menu
                  offset-y
                  offset-x
                  max-width="50%"
                  slot="activator"
                  attach
                >
                  <v-btn
                    slot="activator"
                    icon
                    small
                    :color="themes.client.light.primaryActionButton"
                  >
                    <v-icon small>mdi-information-variant</v-icon>
                  </v-btn>
                  <v-card>
                    <PersonalDetails
                      :profile="application.profile"
                      :actionItems="application.actionItems"
                    />
                  </v-card>
                </v-menu>
                <span> View Personal Information </span>
              </v-tooltip>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex
          v-if="showApplicationNotes"
          d-flex
          xs10
          offset-xs1
          sm8
          offset-sm2
          md5
          offset-md0
        >
          <TabbedFeedback :application="application" />
        </v-flex>
        <v-flex xs1></v-flex>
      </v-layout>
    </v-card-text>

    <v-card-text
      ref="application-profile"
      class="pa-0"
      v-if="application && application.profile"
    >
      <v-layout row wrap>
        <v-flex
          xs10
          offset-xs1
          v-if="
            application.profile.biography &&
            application.profile.biography.length > 0
          "
        >
          <v-toolbar flat color="transparent">
            <div class="headline px-3">Biography</div>
            <v-spacer />
            <Flag icon v-if="bioFlag" :value="bioFlag" />
            <CreateFlag
              v-else
              :target="{ ...application.profile, type: 'Profile' }"
              :profile="application.profile"
              :filter="['biography']"
              @done="refresh"
            >
              <v-btn
                icon
                flat
                :color="themes.client.light.cancel"
                slot="activator"
              >
                <v-icon>mdi-flag</v-icon>
              </v-btn>
            </CreateFlag>
          </v-toolbar>

          <v-card-text class="text-xs-justify">
            <markdown
              :html="false"
              :source="application.profile.biography"
              class="markdown"
            />
          </v-card-text>
        </v-flex>
        <v-flex xs1> </v-flex>
      </v-layout>
      <Experience
        v-if="
          application.profile.experiences && application.profile.experiences[0]
        "
        :experiences="application.profile.experiences"
      />
      <Qualifications
        v-if="
          application.profile.profileQualifications &&
          application.profile.profileQualifications[0]
        "
        :profile="application.profile"
        :actionItems="application.actionItems"
        @refresh="refresh"
      />
      <AdditionalInformation :profile="application.profile" />
    </v-card-text>
  </v-container>
</template>

<script>
// Components
import AdditionalInformation from "@/components/client/candidate/profile/AdditionalInformation";
import ApplicationCompletionDetails from "@/components/client/applications/ApplicationCompletionDetails";
import ApplicationDocuments from "@/components/client/applications/ApplicationDocuments";
import ApplicationPsychometrics from "@/components/client/applications/ApplicationPsychometrics";
import ApplicationQuestionnaire from "@/components/client/applications/ApplicationQuestionnaire";
import ApplicationRating from "@/components/client/applications/ApplicationRating";
import ApplicationsExportSelector from "@/components/client/applications/ApplicationsExportSelector";
import CreateFlag from "@/components/client/flags/CreateFlag";
import Experience from "@/components/client/candidate/profile/Experience";
import FeedbackRequestsForm from "@/components/client/feedback_requests/FeedbackRequestsForm";
import Flag from "@/components/client/flags/Flag";
import Markdown from "vue-markdown";
import MobileNumberValidator from "@/components/candidate/MobileNumberValidator";
import PersonalDetails from "@/components/client/candidate/profile/PersonalDetails";
import Qualifications from "@/components/client/candidate/profile/qualifications/Qualifications";
import TabbedFeedback from "@/components/client/applications/TabbedFeedback";

// Helpers
import _ from "lodash";
import Vue from "vue";
import { generatedDocumentDownloads } from "@/mixins/generatedDocumentDownloads.js";

export default {
  mixins: [generatedDocumentDownloads],

  components: {
    AdditionalInformation,
    ApplicationCompletionDetails,
    ApplicationDocuments,
    ApplicationPsychometrics,
    ApplicationQuestionnaire,
    ApplicationRating,
    ApplicationsExportSelector,
    CreateFlag,
    Experience,
    FeedbackRequestsForm,
    Flag,
    Markdown,
    MobileNumberValidator,
    PersonalDetails,
    Qualifications,
    TabbedFeedback,
  },

  props: {
    application: Object,
    showApplicationNotes: { type: Boolean, default: () => true },
    showApplicationRating: { type: Boolean, default: () => true },
  },

  data() {
    return {
      sharing: false,
      generatingPDF: false,
    };
  },

  computed: {
    isManager() {
      return this.$store.getters["client/opportunities/currentIsManager"]();
    },

    isWithdrawn() {
      return this.application.status === "Withdrawn";
    },

    flags() {
      if (!_.get(this, "application.profile.flags[0]")) return [];
      return this.application.profile.flags.filter(
        (f) =>
          f.targetType === "Profile" &&
          f.targetId === this.application.profile.id
      );
    },
    bioFlag() {
      var filtered = this.flags.filter((f) => f.key.indexOf("biography") >= 0);
      return filtered.length ? filtered[0] : null;
    },
    avatarFlag() {
      var filtered = this.flags.filter((f) => f.key.indexOf("avatar") >= 0);
      return filtered.length ? filtered[0] : null;
    },
    showPsychometrics() {
      return (
        this.application.psychometrics &&
        this.application.psychometrics.filter(
          (p) => p.show || p.provider != "Odyssey" || p.aggregate >= 2
        ).length
      );
    },
  },

  methods: {
    copiedToast(value) {
      this.$store.dispatch("snackbarShow", `Copied ${value}.`);
    },

    refresh() {
      return this.$store.dispatch("client/applications/fetch", {
        id: this.application.id,
      });
    },
    async viewPdf(application) {
      this.generatingPDF = true;
      await this.handleGeneratedDocumentRequest(
        this.$http.get(
          `${this.$root.$api}/client/opportunities/${application.opportunity.id}/applications/${application.id}.pdf`,
          { responseType: "blob" }
        ),
        {
          openInline: true,
          pendingMessage:
            "Your application document has been requested. You will receive an email with a download link.",
          errorMessage: `PDF generation error, please let us know: Application ID ${application.id}.`,
        }
      );

      this.generatingPDF = false;
    },
  },
};
</script>

<style>
.client.applications-application div.rating-wrapper fieldset {
  position: relative;
}
</style>
